import { Injectable } from '@angular/core'
import { NgNotificationServiceInterface } from '@evologi/shared/data-access-api'
import {
  AdminUINotificationCode,
  parseAdminUINotification,
} from './libs/admin-ui-notification.lib'

@Injectable({
  providedIn: 'root',
})
export class AdminUIsRepository {
  constructor(private ngNotificationService?: NgNotificationServiceInterface) {}

  notify(options: { code?: AdminUINotificationCode; message?: string }): void {
    this.ngNotificationService?.show(
      options.message
        ? { title: 'Error', message: options.message, color: 'error' }
        : parseAdminUINotification(options.code),
    )
  }
}
